import { TopConfig } from '../context/ConfigContext';

export const getInsuranceCoveragesServiceConfig = (topConfig: TopConfig, policyNumber: string) => {
    const { insurance: insuranceServiceConfig } = topConfig.services;
    const { url } = insuranceServiceConfig;

    if (!url) {
        throw new Error('Insurance Coverages service: Url not defined');
    }

    return {
        ...insuranceServiceConfig,
        url: `${url}/${policyNumber}/?expand=Supplementary`
    };
};
